// extracted by mini-css-extract-plugin
export default {"content":"styles_content__OrXHu","section":"styles_section__cbQ-1","collapsed":"styles_collapsed__Je6Fl","expanded":"styles_expanded__1BYRZ"};